// extracted by mini-css-extract-plugin
export default {"ctn":"Heroes_ctn__g7viI","wrp":"Heroes_wrp__aXbf0","title":"Heroes_title__ezycH","subtitle":"Heroes_subtitle__bepWV"};